

import DataSourceModel from './DataSourceModel';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import _ from 'lodash';

const notifyJsonStr = JSON.stringify([{
    a: 1,
    b: 2
}, {
    a: 3,
    b: 4
}], null, 2);

export default class SingleValueSourceModel extends DataSourceModel {

    singleValueMap = new PropertyDescriptor([{
        field: 'value',
        value: ''
    }], '字段映射', '数据源', 'fieldMap', "#anticon-bianliang_field", {
        gallery: "数据",
        galleryIndex: 20,
        zIndex: -1,
        // description: '例如，数据为\r\n'+notifyJsonStr+'\r\n'+'表达式为 __allData[0]["a"]+__allData[1]["b"] 将得到值为5;\r\n;表达式也可以直接为字段，如 a ,将得到第一条数据的的字段a值 1'
    });
    constructor() {
        super();
    }
    getData() {
        // return new Promise((resolve, reject) => {
        let data = super.getData();
        let singleValueMap = this.singleValueMap || [];
        if (!singleValueMap[0] || !singleValueMap[0].value || !data[0]) {
            return null
        }
        try {
            let newData = {
                ...data[0],
                __allData: data
            }
            return _.template(`<%= ${singleValueMap[0].value} %>`)(newData);
        } catch (e) {
            return '';
        }
        // return data[0][singleValueMap[0].value];
        // })
    }
}
